import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let store = new Vuex.Store({
  state: {
    terantInfo:{},
    userInfo:{}
  },
  getters:{
    getTerantInfo(state){
      return state.terantInfo
    },
    getUserInfo(state){
      return state.userInfo
    }
  },
  mutations: {
    USER_INFO:(state,data)=>{//用户信息
      state.userInfo = data
    },
    TERANT_INFO: (state, data) => {//租户信息
      state.terantInfo = data
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js